<!--
  工单详情验收评价
-->
<template>
  <div>
    <div class="content-title" style="margin-top: 30px">验收评价</div>
    <div class="flex-c-s">
      <div class="flex-col-center">
        <img :src="evaluate.avatar" class="user-header" />
        <span class="user-name">{{ evaluate.userName }}</span>
      </div>
      <div class="create-time">{{ evaluate.time }}</div>
    </div>
    <div class="eva-content">
      <el-rate v-model="score" disabled> </el-rate>
      <div class="white-pre" style="margin-top: 10px">{{ evaluate.content }}</div>
    </div>
    <div class="order-line" style="margin: 28px 0 31px 0"></div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    evaluate: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    score() {
      if (this.evaluate.score) {
        return Number(this.evaluate.score)
      } else {
        return 1
      }
    }
  },
  watch: {},
  mounted() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.eva-content {
  padding: 20px;
  margin-top: 10px;
  background: #f8faff;
  border-radius: 6px;
  line-height: 26px;
  font-size: 14px;
  color: rgba(41, 48, 82, 0.7);
}
</style>
